import { Button as MUIButton, ButtonProps as MUIButtonProps, CircularProgress, Tooltip } from "@mui/material";
import { PropsWithChildren } from "react";

interface ButtonProps {
    tooltip?: React.ReactNode;
    busy?: boolean;
}

export const Button = ({
    children, id, tooltip, busy, variant, disabled, ...rest
}: PropsWithChildren<ButtonProps & MUIButtonProps>) => {
    return (
        <Tooltip id={`${id}-tooltip`} title={tooltip} arrow>
            <span>
                <MUIButton
                    id={id}
                    variant={variant ?? "contained"}
                    disabled={busy || disabled}
                    {...rest}
                >
                    {!busy &&
                        children
                    }
                    {busy &&
                        <CircularProgress id={`${id}-busy`} size='28px' />
                    }
                </MUIButton>
            </span>
        </Tooltip>

    )
}
